import { apiCall } from "./service";
import { generalActions } from "../actions";
import {
  BASE_URL,
  URL_CLIENTS,
  URL_SEARCH_CLIENTS,
  URL_CLIENT,
  URL_CREATE_CLIENT,
  URL_UPDATE_CLIENT,
  URL_DELETE_CLIENT,
  URL_CLIENT_DETAILS,
  URL_CLIENT_PORTFOLIO,
  URL_CLIENT_PORTFOLIOS,
  URL_CREATE_CLIENT_PORTFOLIO,
  URL_UPDATE_CLIENT_PORTFOLIO,
  URL_DELETE_CLIENT_PORTFOLIO,
  URL_SEARCH_CLIENT_PORTFOLIO,
  URL_SORT_CLIENT_PORTFOLIOS,
  URL_CLIENT_FLAG,
  URL_CLIENT_RESOURCES,
 } from "./URL";
const Id = localStorage.getItem("id");
export const api = {
  clientsRequest(params) {

    const {search, page, size } = params;
    const paginationParams = { pageNumber: page, pageSize: size };
    let url = URL_CLIENTS;

    if (search) {
      paginationParams.searchTerm = search;
    }

    const queryParams = new URLSearchParams(paginationParams).toString();
    const fullUrl = `${url}?${queryParams}`;
  
    return apiCall.pagination({ url: fullUrl });
  },
  sortClientsRequest(params) {
    return apiCall.pagination({url: `${URL_CLIENTS}?pageNumber=${params.page}&pageSize=${params.size}&orderby=${params.orderBy}`, isAuthToken: true});
  },
  fetchSingleClientDataRequest(id) { 
    return apiCall.get({url: `${URL_CLIENT}${id}`});
  },
  searchClientsRequest(params) {
    return apiCall.get({ url: `${URL_SEARCH_CLIENTS}${params}`, isAuthToken: true, params });
  },
  createClientRequest(params) {
    return apiCall.filePost({ url: URL_CREATE_CLIENT, params: params.finalPayload });
  },

  updateClientRequest(params) {
    return apiCall.put({ url: `${URL_UPDATE_CLIENT}${params.id}`, params: params.payload });
  },
  deleteClientRequest(params) {
    return apiCall.delete({ url: `${URL_DELETE_CLIENT}${params.id}` });
  },
  getClientDetailsRequest(params) {
    return apiCall.get({ url: `${URL_CLIENT_DETAILS}${params.id}` });
  },
  getClientIndustriesRequest(id) {
    return apiCall.get({ url: `${URL_CLIENT}${id}/industries`, isAuthToken: true });
  },
  updateClientFlagRequest(params) {
    return apiCall.patch({ url: `${URL_CLIENT_FLAG}${params.id}`, params: params.payload });
  },
  deleteClient(id) {
    return apiCall.delete({ url: `${URL_DELETE_CLIENT}${id}` });
  },
  ////////////////////////////////////////////////// PORTFOLIOS ////////////////////////////////////////////////// 

  portfoliosRequest(params) {
    return apiCall.pagination({url: `${URL_CLIENT}${params.id}${URL_CLIENT_PORTFOLIOS}?pageNumber=${params.page}&pageSize=${params.size}`, isAuthToken: true, params });
  },
  sortPortfoliosRequest(params) {
    return apiCall.pagination({url: `${URL_SORT_CLIENT_PORTFOLIOS}?pageNumber=${params.page}&pageSize=${params.size}&orderby=${params.orderBy}`, isAuthToken: true});
  },
  fetchSinglePortfolioDataRequest(id) { 
    return apiCall.get({url: `${URL_CLIENT_PORTFOLIO}${id}`});
  },
  searchPortfoliosRequest(params) {
    return apiCall.get({ url: `${URL_SEARCH_CLIENT_PORTFOLIO}?clientId=${params.id}&searchTerm=${params.searchText}`, isAuthToken: true });
  },
  createPortfolioRequest(params) {
    return apiCall.post({ url: `${URL_CREATE_CLIENT_PORTFOLIO}`, params: params.payload });
  },
  updatePortfolioRequest(params) {
    return apiCall.put({ url: `${URL_UPDATE_CLIENT_PORTFOLIO}${params.id}`, params: params.payload });
  },
  deletePortfolioRequest(params) {
    return apiCall.delete({ url: `${URL_DELETE_CLIENT_PORTFOLIO}${params.id}` });
  },

  ////////////////////////////////////////////////// ALLOCATED RESOURCES ////////////////////////////////////////////////// 

  getAllocatedResourcesRequest(params) {
    return apiCall.pagination({url: `${URL_CLIENT_RESOURCES(params.id)}?pageNumber=${params.page}&pageSize=${params.size}`, isAuthToken: true, params });
  },
  sortAllocatedResourcesRequest(params) {
    return apiCall.pagination({url: `${URL_CLIENT_RESOURCES(params.id)}?pageNumber=${params.page}&pageSize=${params.size}&orderby=${params.orderBy}`, isAuthToken: true});
  },
  getTeam(id) {
    return apiCall.get({url: `${URL_CLIENT}${id}/Detailed-Resources`});
  },
  getOrgChart(id, scope) {
    return apiCall.get({url: `${URL_CLIENT}${id}/OrgChart?scope=${scope}`});
  },
  AddResourceToClient(clientId, resourceId) {
    return apiCall.post({url: `${URL_CLIENT}${clientId}/Resources/${resourceId}`});
  },
  RemoveResourceFromClient(clientId, resourceId) {
    return apiCall.delete({url: `${URL_CLIENT}${clientId}/Resources/${resourceId}`});
  }

  ////////////////////////////////////////////////// PROGRAMS ////////////////////////////////////////////////// 

  // getProgramsRequest(params) {
  //   return apiCall.pagination({url: `${URL_CLIENT_PROGRAMS}?pageNumber=${params.page}&pageSize=${params.size}&clientId=${params.id}`, isAuthToken: true, params });
  // },
  // fetchProgramDataRequest(params) { 
  //   return apiCall.get({url: `${URL_CLIENT_PROGRAM}${params.id}`});
  // },
  // sortProgramsRequest(params) {
  //   return apiCall.pagination({url: `${URL_CLIENT_PROGRAMS}?pageNumber=${params.page}&pageSize=${params.size}&clientId=${params.id}&orderby=${params.orderBy}`, isAuthToken: true});
  // },
  // createProgramsRequest(params) {
  //   return apiCall.post({ url: `${URL_CREATE_CLIENT_PROGRAMS}`, params: params.payload });
  // },
  // updateProgramsRequest(params) {
  //   return apiCall.put({ url: `${URL_UPDATE_CLIENT_PROGRAMS}${params.id}`, params: params.payload });
  // },
  // deleteProgramsRequest(params) {
  //   return apiCall.delete({ url: `${URL_DELETE_CLIENT_PROGRAMS}${params}` });
  // },
};

export default api;
